import { memo, useEffect } from "react";

const Component = ({ DATATYPE, handleChange }) => {
    useEffect(() => {
        console.log("re-render",DATATYPE);

    }, []);
  return (
    <input
      className="form-control"
      type={DATATYPE === "TEXT" ? "text" : "number"}
      onChange={(e) => {
        const { value } = e.target;
        // setChangeData(prev=>{
        //   const newPrev = [...prev]

        //   console.log("isDataUpdate", newPrev,)

        //   return newPrev
        // })
        handleChange(value);
        // handleChangeData(value, item, {}, dataUpdate, true);
        // if (
        //   refParams.current &&
        //   refParams.current.length > 0 &&
        //   refParams.current.find(
        //     ({ value }) => value === item.value
        //   )
        // ) {
        //   setParams(e.target.value);
        // }
      }}
      // value={
      //   dataChangeRef.current[dataUpdate][item.value]
      // }
    />
  );
};

export const Item = memo(Component, (prevProps, newProps) => {
 
  if (prevProps.DATATYPE !== newProps.DATATYPE) {
    return false;
  }

    return true;
});
